module.exports = __webpack_public_path__ + "static/media/PC4-6-2.ebef253e.jpg";